<span class="copy-text-link">
  <a class="copy-text-click-area"
     (click)="copyTextToClipboard($event)"
     [attr.data-automation-id]="'bc-copy-text-to-clipboard'">
    {{ linkText }}
    <ng2-tooltip [direction]="'top'" [text]="textToCopy"></ng2-tooltip>
  </a><span class="copy-text-link-feedback">&nbsp;{{ 'copyTextToClipboard.copyFeedbackText' | translate }}</span>
</span>
